import React, {Component, PropTypes} from 'react';
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
// import ReactTooltip from 'react-tooltip'
import Helmet from 'react-helmet'
// import Loader from 'react-loader'
import { Link as ScrollLink } from 'react-scroll'
import config from 'config'
import container from '../../helpers/container'
import format from '../../helpers/format'
import * as searchActions from 'redux/modules/search'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  ScrollToTop,
  SignupForm,
  Grade,
} from '../../components'
import Styles from './TspToolkit.css'
import imageSocialShare from '../../../static/images/tsp-social-share.png'


@CSSModules(Styles, { allowMultiple: true })
class TspFundItem extends Component {
  static propTypes = {
    fund: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
  }

  getShareclassUrl(shareclass){
    // const A = `${config.domain}`
    const B = `${config.routes.fund}/`
    const C = `${format.sanitize(shareclass.fund_legal_name)}/`
    const D = 'N/'
    const E = `${config.profilePath}/`
    const F = `${shareclass.fund_id}/`
    const G = `${shareclass.investment_vehicle_id}/`

    return `${B}${C}${D}${E}${F}${G}`
  }

  render() {
    if (!this.props.fund) { return null }
    const e = this.props.fund
    if (!e.grade_fossil) {
      return (
      <div styleName='tsp-fund-item-inactive'>
        { e.fund_legal_name === 'L Income' ?
            e.fund_legal_name :
            e.fund_legal_name.slice(4,10)
        } <div styleName='tsp-inactive-asterisk'>*</div>
      </div>
      )
    }
    return (
      <Link
        to={this.getShareclassUrl(e)}
        title={e.fund_legal_name}
      >
        <div styleName='tsp-fund-item'>
          {e.fund_legal_name.slice(4,10)}
          <div styleName='tsp-fund-item-grade'>
            <span>{format.perc(e.c2f5coogutweight)}</span>
            <Grade grade={e.grade_fossil} blocksmall/>
          </div>

        </div>
      </Link>
    )
  }
}


@connect(
  state => ({
    result: state.tspShareClass.result,
    searching: state.tspShareClass.loading,
    searched: state.tspShareClass.loaded,
    error: state.tspShareClass.error,
  }),
  searchActions)

@CSSModules(Styles, { allowMultiple: true })
export default class TspToolkit extends Component {
  static propTypes = {
    searching: PropTypes.bool,
    searched: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.array,
  }

  static contextTypes =  {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    const emailTo = ''
    const emailToAdmin = 'thriftline@tsp.gov'
    const emailSubjectAdmin = 'The TSP needs climate safe investment options'
    const emailSubjectColleagues = 'Our retirement savings are fueling the climate crisis'

    const planAdminEmailText = `Dear Federal Retirement Thrift Investment Board,

I participate in the Federal Thrift Savings (TSP) plan, and I’m writing to ask: How is the TSP managing the climate-related investment risks that are threatening my retirement savings?

I recently learned the TSP invests over $35 billion in fossil fuel companies. Climate change is accelerating, resulting in a growing number of climate-related natural disasters, and the economic impacts are becoming increasingly evident. Climate-related investment risk is the risk that the economic impacts of climate change will cause your investments to suffer losses. Achieving decarbonization of the world economy requires a transition away from carbon-based energy, which will necessarily alter some companies’ businesses. High-carbon industries face some of the most climate risks, and addressing climate-related investment risk usually involves carefully scrutinizing investments in these sectors.

The TSP has a fiduciary duty of prudent and loyal stewardship, with the responsibility to act in our best interest and protect our life savings from these material, climate-related financial risks. 

The analysis of the fossil fuel investments in the TSP is here:

https://fossilfreefunds.org/thrift-savings-plan 

I understand TSP plan participants have access to a “mutual fund window”, also known as a self-directed option. This gives plan participants access to a wider range of fund options, including climate-safe sustainable funds. But the window comes with higher fees, limits on who can use it, and limits on how much can be invested. More broadly, plans that offer self-directed options usually see only between 1 and 2% of plan assets invested through them. Self-directed retirement options shift the practical responsibility for risk management from the plan to the participant. At best, it’s a band-aid that doesn’t address the climate risk facing the vast majority of the plan's assets.

I appreciate your time and look forward to hearing from you.

Best,

[Your Name]
    `

    const colleagueEmailText = `Dear [colleague],

I just found out our retirement plan, the Thrift Savings Plan (TSP), is investing over $35 BILLION in fossil fuel companies. Our retirement savings are fueling the climate crisis.

You can see the analysis on what's inside the TSP investment options here:

https://fossilfreefunds.org/thrift-savings-plan 

I care about solving the climate crisis, and I don’t want my retirement savings invested in companies that are destroying the environment, exposing my nest egg to climate-related financial risk.

We need sustainable, climate-friendly investment options inside our retirement plan so we can invest in the sustainable economy of the future.

You can use this toolkit to learn how to invest in a sustainable world:

https://fossilfreefunds.org/thrift-savings-plan-toolkit 

Thank you for taking the time to listen.

Best,

[Your Name]
    `

    const planAdminEmailHref = `mailto:${emailToAdmin}?subject=${encodeURIComponent(emailSubjectAdmin)}&body=${encodeURIComponent(planAdminEmailText)}`

    const colleagueEmailHref = `mailto:${emailTo}?subject=${encodeURIComponent(emailSubjectColleagues)}&body=${encodeURIComponent(colleagueEmailText)}`

    this.state = {
      tspByType: this.defaultTspByType(),
      title: 'Five steps to a sustainable retirement through the Thrift Savings Plan (TSP)',
      description: 'Resources for people to take action to make the Thrift Savings Plan (TSP) more sustainable.',
      url: config.domain + config.routes.tspToolkit,
      planAdminEmailHref,
      colleagueEmailHref
    }
  }

  componentWillMount() {
    // if (typeof window !== 'undefined') {
    //   window.scrollTo(0,0)
    // }
    this.props.tspShareClasses()
  }

  componentWillReceiveProps(props) {
    // split into L, Ind -> (E, B)
    const tspByType = this.defaultTspByType()

    props.result.forEach((r)=>{
      if (r.fund_legal_name.slice(0,5) === 'TSP L') {
        tspByType.L.push(r)
      } else {
        tspByType.E.push(r)
      }
    })

    tspByType.L = tspByType.L.sort((a, b) => { return b.fund_legal_name.localeCompare(a.fund_legal_name) })
    tspByType.E = tspByType.E.sort((a, b) => { return a.net_assets - b.net_assets })

    tspByType.L.push({'fund_legal_name': 'TSP L 2025'})
    tspByType.L.push({'fund_legal_name': 'L Income'})

    this.setState({
      tspByType: tspByType
    })
  }

  defaultTspByType(){
    return {
      'L': [],
      'E': [],
      'B': []
    }
  }

  render() {
    const finRisk1 = require('../../../static/images/fin-risk-oil-chart.jpg')
    const finRisk2 = require('../../../static/images/fin-risk-deforestation.jpg')
    const navIcons = {
      1: require('../../../static/images/action-center-employees/icon1.jpg'),
      2: require('../../../static/images/action-center-employees/icon2.jpg'),
      3: require('../../../static/images/action-center-employees/icon3.jpg'),
      4: require('../../../static/images/action-center-employees/icon4.jpg'),
      5: require('../../../static/images/action-center-employees/icon5.jpg'),
    }

    const { planAdminEmailHref, colleagueEmailHref } = this.state
    const socialShareUrl =  config.domain+imageSocialShare.replace(/.*dist/,'/dist')

    return (
      <div id='top'>
        <Helmet meta={[
          {property: 'og:image', content: socialShareUrl},
          {property: 'twitter:image', content: socialShareUrl},
        ]}/>
        {
          container.helmet(
            this.statetitle,
            this.statedescription,
            this.stateurl
          )
        }

        <div styleName='page'>
          <ContainerDivs>
            <h1 styleName='small-page-title'>
              {this.state.title}
            </h1>

            <section>
              <div styleName='answer-info'>
                <p>
                  Are your retirement savings funding the climate crisis through the Thrift Savings Plan (TSP)? If you don’t know, you’re not alone. The TSP invests more than $700 billion on behalf of over 6 million civilian and military plan participants, but very few know which companies they are funding with their retirement dollars. Using this toolkit, you will learn how to lower your financial risks from unsustainable investments and maybe even help your co-workers do the same.
                </p>
              </div>
            </section>

            <nav styleName='icon-nav'>
              {
                [
                  [0, 'learn-about-the-financial-risks-of-unsustainable-investments', 'Learn about the financial risks of unsustainable investments'],
                  [0, 'know-what-you-own', 'Know what you own'],
                  [0, 'take-action', 'Take action'],
                  [0, 'become-a-change-agent', 'Become a change agent'],
                  [0, 'join-the-movement', 'Join the movement'],
                ].map((e, i)=>{
                  return (
                    <button
                      key={e[1]}
                      styleName='scroll-to-item'
                    >
                      <ScrollLink
                        to={e[1]}
                        spy
                        smooth
                        offset={0}
                        duration={500}
                        title={e[2]}
                      >
                        <img
                          src={navIcons[i + 1]}
                          alt={e[2]}
                        />
                        <div styleName={'level-'+e[0]}>{e[2]}</div>
                      </ScrollLink>
                    </button>
                  )
                })
              }
            </nav>
            <hr/>


            <div styleName='answer'>
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              <section>
                <div styleName='anchor' id='learn-about-the-financial-risks-of-unsustainable-investments' />

                <h2 styleName='answer-subtitle-flex'>
                  <div styleName='answer-subtitle-bbl'>
                    1
                  </div>
                  <div>
                    Learn about the financial risks of unsustainable investments
                  </div>
                </h2>

                <div styleName='answer-info'>

                  <div styleName='text-img-cols'>
                    <div styleName='text-img-cols-text'>
                      <h3>
                        Unsustainable investments could put your 401(k) at risk
                      </h3>
                      <p>
                        There is a widespread myth that investing sustainably
                        means sacrificing returns. But if anything, the evidence
                        suggests the opposite is true. <Link
                          to={'https://investyourvalues.org/action-center/financial-risks'}
                          title='Financial risks of unsustainable investments'
                          xstrong
                        >Learn more<LinkIcon /></Link>
                      </p>
                    </div>
                    <div styleName='text-img-cols-img'>
                      <Link
                        to={'https://investyourvalues.org/action-center/financial-risks'}
                        title='Financial risks of unsustainable investments'
                      >
                        <img
                          src={finRisk1}
                          alt='Financial risks of unsustainable investments'
                        />
                      </Link>
                    </div>
                  </div>

                  <div styleName='text-img-cols'>
                    <div styleName='text-img-cols-text'>
                      <h3>
                        The TSP is fueling the climate crisis
                      </h3>
                      <p>
                        The TSP invests over $35 billion in fossil fuel companies which are fueling the climate crisis. We can't meet the goals of the Paris Climate Agreement and limit global warming to 1.5˚C while expanding coal, oil, and gas. <Link
                          to={'https://investyourvalues.org/the-issues/fossil-fuels'}
                          title='Asset managers are investing in the climate crisis'
                          xstrong
                        >Learn more<LinkIcon /></Link>
                      </p>
                    </div>
                    <div styleName='text-img-cols-img'>
                      <Link
                        to={'https://investyourvalues.org/the-issues/fossil-fuels'}
                        title='Asset managers are investing in the climate crisis'
                      >
                        <img
                          src={finRisk2}
                          alt='Asset managers are investing in the climate crisis'
                        />
                      </Link>
                    </div>
                  </div>

                  <ScrollToTop />
                  <hr/>
                </div>
              </section>
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              <section>
                <div styleName='anchor' id='know-what-you-own' />

                <h2 styleName='answer-subtitle-flex'>
                  <div styleName='answer-subtitle-bbl'>
                    2
                  </div>
                  <div>
                    Know what you own
                  </div>
                </h2>

                <div styleName='answer-info'>

                  <p>
                    Now that you have uncovered the risk associated with unsustainable retirement investments, it’s time to find out if your investments are exposed to these risks.
                  </p>

                  <h3>
                    Find your investments
                  </h3>
                  <p>
                    To start, <Link
                      to={'https://www.tsp.gov/login/'}
                      title='TSP.gov Login'
                      xstrong
                    >log in</Link> to your TSP account to look up what fund(s) you are currently invested. Write your fund(s) down then continue to the next step.
                  </p>

                  <div styleName='one-col'>
                    <Link
                      to={'https://www.tsp.gov/login/'}
                      title='TSP.gov Login'
                      transparentbutton
                    >
                      TSP.gov Login<LinkIcon/>
                    </Link>
                  </div>

                  <h3>
                    Find your fund grades
                  </h3>
                  <p>
                    Now visit our TSP analysis to look up the fossil fuel grades for your investments.
                  </p>

                  <div styleName='funds-nav-wrap'>
                    {
                      this.state.tspByType.E.map((e,i) => {
                        return <TspFundItem key={'l-funds-'+i} fund={e} />
                      })
                    }

                    {
                      this.state.tspByType.L.map((e,i) => {
                        return <TspFundItem key={'l-funds-'+i} fund={e} />
                      })
                    }

                    {
                      [
                        {'fund_legal_name': 'TSP G Fund'},
                        {'fund_legal_name': 'TSP F Fund'},
                      ].map((e,i) => {
                        return <TspFundItem key={'l-funds-'+i} fund={e} />
                      })
                    }
                  </div>

                  <div styleName='one-col'>
                    <Link
                      to={config.routes.tspLanding}
                      title='TSP homepage | Fossil Free Funds'
                      transparentbutton
                    >
                      See full analysis<LinkIcon/>
                    </Link>
                  </div>

                  <p>
                    <i>* Bond fund results are currently unavailable. Check back soon.</i>
                  </p>

                  <br/>
                  <br/>

                  <ScrollToTop />
                  <hr/>
                </div>
              </section>
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              <section>
                <div styleName='anchor' id='take-action' />

                <h2 styleName='answer-subtitle-flex'>
                  <div styleName='answer-subtitle-bbl'>
                    3
                  </div>
                  <div>
                    Take action
                  </div>
                </h2>

                <div styleName='answer-info'>

                  <h3>
                    Consider the self-directed option
                  </h3>
                  <p>
                    In 2022, the TSP added a "mutual fund window", also known as a self-directed option. This gives plan participants access to a wider range of fund options, including climate-safe sustainable funds.
                  </p>

                  <p>
                    <b><i>Take note:</i></b> The self-directed option comes with higher fees, limits on who can use it, and limits on how much can be invested. More broadly, plans that offer self-directed options usually see only between 1 and 2% of plan assets invested through them. Self-directed retirement options shift the practical responsibility for risk management from the plan to the participant. At best, it’s a band-aid that doesn’t address the climate risk facing the vast majority of the plan's assets.
                  </p>

                  <p>
                    You can use our Fossil Free Funds database to find mutual funds that avoid fossil fuel investments. Some, though not all, of these funds may be available through the TSP mutual fund window.
                  </p>

                  <div styleName='one-col'>
                    <Link
                      to={config.routes.list}
                      title='Search funds | Fossil Free Funds'
                      transparentbutton
                    >
                      Fossil Free Funds<LinkIcon/>
                    </Link>
                  </div>

                  <ScrollToTop />
                  <hr/>
                </div>
              </section>
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              <section>
                <div styleName='anchor' id='become-a-change-agent' />

                <h2 styleName='answer-subtitle-flex'>
                  <div styleName='answer-subtitle-bbl'>
                    4
                  </div>
                  <div>
                    Become a change agent
                  </div>
                </h2>

                <div styleName='answer-info'>
                  <h3>
                    Contact the TSP plan administrator
                  </h3>
                  <p>
                    The <Link
                      to={'https://www.frtib.gov/'}
                      title='Federal Retirement Thrift Investment Board'
                      xstrong
                    >Federal Retirement Thrift Investment Board (FRTIB)</Link> is the TSP plan administrator, charged by law to administer the TSP solely in the interest of the participants and beneficiaries. Here’s an email we have written for you to get started.
                  </p>

                  <div styleName='one-col'>
                    <Link
                      to={planAdminEmailHref}
                      title="Email your plan admin"
                      targetBlank
                    >
                      <div styleName='take-action-icons'>
                        <p>
                          Email your plan admin
                        </p>
                        <div>
                          <LinkIcon nospace faclass='fa-envelope'/>
                        </div>
                      </div>
                    </Link>
                  </div>

                  <h3>
                    Email your co-workers and form a coalition
                  </h3>
                  <p>
                    If you’re writing to someone in power, advocating on behalf of 20 or even 10 people carries a lot more weight than just one. One way to spur interest would be to share the results from our tools with your fellow employees. All plan participants are offered the same basket of mutual funds as you are, so they are probably asking the same questions are you are right now.
                  </p>

                  <div styleName='one-col'>
                    <Link
                      to={colleagueEmailHref}
                      title='Email your colleagues'
                      targetBlank
                    >
                      <div styleName='take-action-icons'>
                        <p>
                          Email your colleagues
                        </p>
                        <div>
                          <LinkIcon nospace faclass='fa-envelope'/>
                        </div>
                      </div>
                    </Link>
                  </div>

                  <ScrollToTop />
                  <hr/>
                </div>
              </section>
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              <section>
                <div styleName='anchor' id='join-the-movement' />

                <h2 styleName='answer-subtitle-flex'>
                  <div styleName='answer-subtitle-bbl'>
                    5
                  </div>
                  <div>
                    Join the movement
                  </div>
                </h2>

                <div styleName='answer-info'>
                  <p>
                    Now it is time to join the movement by advocating your power to invest in an economy that is based on justice and sustainability.
                  </p>

                  <h3>
                    Sign up for updates
                  </h3>
                  <p>
                    We'll let you know when new information is added to our database.
                  </p>

                  <SignupForm />

                  <h3>
                    Support <i>As You Sow</i>
                  </h3>
                  <p>
                    <i>As You Sow</i>, the nonprofit behind Invest Your Values, has leveraged the power of shareholders to change the world’s biggest corporations for good since 1992. Every day, your gift helps tackle today’s toughest issues, like climate change, racial justice, ocean plastics, toxins in the food system, egregious CEO pay, and slavery in corporate supply chains. Consider joining our family of donors.
                  </p>

                  <div styleName='one-col'>
                    <Link
                      to={config.links.donate}
                      title='Donate to As You Sow'
                      transparentdonatebutton
                    >
                      Donate to <i>As You Sow</i><LinkIcon/>
                    </Link>
                  </div>

                  <br/>
                  <br/>

                  <ScrollToTop />
                  <hr/>
                </div>
              </section>
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
              { /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */ }
            </div>

          </ContainerDivs>
        </div>
      </div>
    )
  }
}